import React, { ReactElement } from "react";
import PageNotFoundImage from "./icons/error.svg";
import "./PageNotFound.scss";

const PageNotFound = (): ReactElement<{}> => {
  return (
    <div className="page-not-found-container">
      <img src={PageNotFoundImage} alt="Page Not Found" />
      <div className="error-message">Something went wrong!</div>
      <div className="error-subtitle">
        Oops! The requested page was not found.
        <br />
        Please check the URL and try again.
      </div>
    </div>
  );
};

export default PageNotFound;
